import VuetifyConfirm from 'vuetify-confirm'
import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
Vue.use(VuetifyConfirm, { vuetify })
